import { SingleOperation } from "../operations/Operation";
import { Verb } from "../types/Verb";
import { PartialUnknownShape, AttributeKey } from "../types/attributes";
import { WBEventUpsertSubjectAttributeManyPayload } from "../types/WBEvent2";
import { makeAttributeList } from "../ShapeStore";
import { ShapeType } from "@/wbcontroller/types/ShapeType";

export class EditOperation extends SingleOperation {
  shapeType: ShapeType;

  // Remember attributes in 'original' that are present in 'update'
  constructor(
    subjectID: string,
    shapeType: ShapeType,
    original: PartialUnknownShape,
    update: PartialUnknownShape
  ) {
    const derivedOriginal: Record<string, unknown> = {};
    for (const k in update) {
      derivedOriginal[k as string] = original[k as AttributeKey];
    }

    const backwardEvent: WBEventUpsertSubjectAttributeManyPayload = {
      verb: Verb.UpsertSubjectAttributeMany,
      subjectID,
      version: -1,
      attributes: makeAttributeList(derivedOriginal),
    };

    const forwardEvent: WBEventUpsertSubjectAttributeManyPayload = {
      verb: Verb.UpsertSubjectAttributeMany,
      subjectID,
      version: -1,
      attributes: makeAttributeList(update),
    };

    super([forwardEvent], [backwardEvent]);
    this.shapeType = shapeType;
  }

  get label(): string {
    return `Edit ${this.shapeType}`;
  }
}
